<h1 mat-dialog-title>Conferma</h1>
<div mat-dialog-content>
  <p>Sei sicuro di voler rimuovere il certificato <strong>{{data}}</strong>?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()">Si</button>
  <button mat-button (click)="onNoClick()">Annulla</button>
</div>
